import { render, staticRenderFns } from "./AllEvents.vue?vue&type=template&id=f18107a6&scoped=true&"
import script from "./AllEvents.vue?vue&type=script&lang=js&"
export * from "./AllEvents.vue?vue&type=script&lang=js&"
import style0 from "./AllEvents.vue?vue&type=style&index=0&id=f18107a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18107a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
